import React from 'react';
import { Link } from 'react-router-dom';
import flower from '../../../images/icon/flower-icon.svg';
import brand1 from '../../../images/brand/logo01.png';
import brand2 from '../../../images/brand/logo02.png';
import brand3 from '../../../images/brand/logo03.png';
import brand4 from '../../../images/brand/logo04.png';
import brand5 from '../../../images/brand/logo05.png';
import brand6 from '../../../images/brand/logo06.png';
import brand7 from '../../../images/brand/logo07.png';
import brand8 from '../../../images/brand/logo08.png';
import brandPython from '../../../images/brand/logo-python.png';
import brandNodeJs from '../../../images/brand/logo-nodejs.png';
import brandJava from '../../../images/brand/logo-java.png';
import brandAzure from '../../../images/brand/logo-azure.png';
import brandAWS from '../../../images/brand/logo-aws.png';
import brandGCP from '../../../images/brand/logo-gcp.png';

const BrandSection = () => {

  return (
    <section className="brand pt-135 pb-140" style={{ backgroundColor: "#111112" }}>
      <div className="container">
        <div className="xb-brand-title mb-65">
          <img src={flower} alt="" />
          <span>Technical stacks we mastered</span>
          <img src={flower} alt="" />
        </div>
        <div className="xb-brand-wrap">
          <div className="xb-brand-item">
            <div className="xb-brand-single xb-brand-hover">
              <Link to="#">
                <img src={brand2} alt="React" />
              </Link>
              <Link to="#" className="xb-overlay"></Link>
            </div>
            <div className="xb-brand-single xb-brand-hover">
              <Link to="#">
                <img src={brandPython} alt="PYthon" />
              </Link>
              <Link to="#" className="xb-overlay"></Link>
            </div>
          </div>
          <div className="xb-brand-item xb-brand-item--big xb-brand-hover">
            <Link to="#">
              <img src={brandNodeJs} alt="Node JS" />
            </Link>
            <Link to="#" className="xb-overlay"></Link>
          </div>
          <div className="xb-brand-item">
            <div className="xb-brand-single xb-brand-hover">
              <Link to="#">
                <img src={brandJava} alt="Java" />
              </Link>
              <Link to="#" className="xb-overlay"></Link>
            </div>
            <div className="xb-brand-single xb-brand-hover">
              <Link to="#">
                <img src={brand7} alt="Microsoft .NET" />
              </Link>
              <Link to="#" className="xb-overlay"></Link>
            </div>
          </div>
          <div className="xb-brand-item xb-brand-item--big xb-brand-hover">
            <Link to="#">
              <img src={brandAzure} alt="Azure" />
            </Link>
            <Link to="#" className="xb-overlay"></Link>
          </div>
          <div className="xb-brand-item">
            <div className="xb-brand-single xb-brand-hover">
              <Link to="#">
                <img src={brandAWS} alt="AWS" />
              </Link>
              <Link to="#" className="xb-overlay"></Link>
            </div>
            <div className="xb-brand-single xb-brand-hover">
              <Link to="#">
                <img src={brandGCP} alt="GCP" />
              </Link>
              <Link to="#" className="xb-overlay"></Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandSection;
